<script>
export default {
  name: 'NewColorPicker',
  props: {
    propsInputValue: {
      type: String,
      default: 'rgba(190, 190, 190, 1)',
    },
    width: {
      type: [String, Number],
      default: '100',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      menu_switch: false,
      input_value: this.propsInputValue,
      color_picker: this.rgbaToObj(this.propsInputValue),
      is_change: false,
    }
  },
  watch: {
    propsInputValue: {
      handler(new_val) {
        this.input_value = new_val
        this.color_picker = this.rgbaToObj(new_val)
      },
    },
    menu_switch: {
      handler(new_val) {
        if (!new_val) {
          this.finalConfirmColor()
        }
      },
    },
  },
  methods: {
    rgbaToObj(rgba) {
      const [r, g, b, a] = rgba.match(/\d+/g).map(Number)
      const alpha = a ? a : 1
      return { r, g, b, a: alpha }
    },
    updateColor(new_value) {
      this.is_change = true
      const new_color = `rgba(${new_value.rgba.r}, ${new_value.rgba.g}, ${new_value.rgba.b}, ${new_value.rgba.a})`
      const payload = {
        label: this.label,
        value: new_color,
        is_preview: true,
      }
      this.$emit('update-color', payload)
    },
    finalConfirmColor() {
      // 有改過顏色才回傳
      if (this.is_change) {
        const new_color = `rgba(${this.color_picker.r}, ${this.color_picker.g}, ${this.color_picker.b}, ${this.color_picker.a})`
        const payload = {
          label: this.label,
          value: new_color,
        }
        this.$emit('update-color', payload)
        this.is_change = false
      }
    },
  },
}
</script>

<template>
  <v-menu v-model="menu_switch" offset-y :style="`width: ${width}%`" :close-on-content-click="false">
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="input_value"
        dense
        outlined
        readonly
        hide-details
        color="primary"
        :disabled="disabled"
        :label="label"
        :style="`width: ${width}%`"
        v-bind="attrs"
        v-on="on"
        @click="menu_switch = true"
      />
    </template>
    <v-color-picker
      v-model="color_picker"
      dot-size="16"
      swatches-max-height="140"
      mode="rgba"
      @update:color="updateColor"
    />
  </v-menu>
</template>
